import { CAT_NECESSARY, CAT_ANALYTICS } from "../constants.js";

const translation = {
  consentModal: {
    title: "መግለጺ ናይ ኩኪዎች",
    description:
      "ንስራሕ ዘለዎ ድር ጠቕላላ ብትኽክል ክሰርሕ ኩኪዎች ኣስፈላጊ እንተዘለዎም ንጥቀመሉ። እንዳንዶም ክትኽክል ናይ ኩኪዎች ንምክታተል እንጥቀመሉ እንታይ እንትሃቡ ንምፍላጥ እዩ እተሓዘ። ነዚ ናይ ኩኪዎች ምምሕዳር ብቕቡልኩም ብብልጽግና እዮም ንምስእሕቲ።",
    acceptAllBtn: "ኩሉ ተቐበል",
    acceptNecessaryBtn: "ኩሉ ኣይተቐበለን",
    showPreferencesBtn: "ብዝያዳ ምምሕዳር ተግባራት",
  },
  preferencesModal: {
    title: "ናይ ኩኪዎች ምርጫታት ኣምሓድር",
    acceptAllBtn: "ኩሉ ተቐበል",
    acceptNecessaryBtn: "ኩሉ ኣይተቐበለን",
    savePreferencesBtn: "ዝተመረፀ ኣሁን ተቐበል",
    closeIconLabel: "መስኮት ዝግ",
    sections: [
      {
        title: "ናይ ኩኪዎች ተጠቃሚነት",
        description:
          "ንስራሕ ናይ ድር ጣቢት ኣስፈላጊ ፍንታት ምድጋም እና ተሳትፎኹም ናይ ብርሂ ልምድ ምምሕላፍ ኩኪዎች ንጥቀመሉ።",
      },
      {
        title: "ኩኪዎች ንጽጽር ኣስፈላጊ",
        description:
          "እዚ ኩኪዎች ናይ ድር ጣቢት ብትኽክል ክሰርሕ ኣስፈላጊ እዩ፣ ንምሳሌ ምርግጋእ ናይ ተጠቃሚ።",
        linkedCategory: CAT_NECESSARY,
        cookieTable: {
          headers: {
            name: "ስም",
            domain: "ኣገልግሎት",
            description: "መግለጺ",
            expiration: "ብኽብዲ ጊዜ",
          },
          body: [
            {
              name: "_care_leavers_social_hub_session",
              domain: "www.secure-messaging.co.uk",
              description: "ኩኪ ብዲጂታል መድረኽ ብኣሕቢር ማህበር ንምርግጋእ ተጠቕሞ ተዘግበ።",
              expiration: "ዙርያ ጊዜ",
            },
            {
              name: "CSRF-TOKEN",
              domain: "www.secure-messaging.co.uk",
              description: "ኩኪ ብዲጂታል መድረክ ንምርግጋእ ተጠቕሞ ተዘግበ።",
              expiration: "ዙርያ ጊዜ",
            },
            {
              name: "__cf_bm",
              domain: ".www.secure-messaging.co.uk",
              description:
                "እዚ ኩኪ ምኽንያት ሰባትን ሮቦትን ምልያይ እንትሕር እና ድር ጣቢት ካብ ራስኣካል ጥቕጣቕ ንምትሕንና ክረኽቢ። ዝኾነ ግል ውሂብ ኣይተሰብሰበን።",
              expiration: "30 ደቒቕ",
            },
          ],
        },
      },
      {
        title: "ትንታነት",
        description:
          "ኩኪዎች ናይ ትንታነት ምርክብ ውሂብን ንምቕያር ባህሪ ተጠቃሚ እንዳተጋገየ ንምፍላጥ ክረኽበና። እነዚ ግንዛብ ናይ ይዕቲ ባህሪ ምምዕርፍን ናይ ተጠቃሚ ልምድ ምምሕላፍን ክትረኽብ።",
        linkedCategory: CAT_ANALYTICS,
        cookieTable: {
          headers: {
            name: "ስም",
            domain: "ኣገልግሎት",
            description: "መግለጺ",
            expiration: "ብኽብዲ ጊዜ",
          },
          body: [
            {
              name: "_ga",
              domain: "Google Analytics",
              description:
                'ኩኪ ብ <a href="https://business.safety.google/adscookies/">Google Analytics</a> ተዘግበ።',
              expiration: "ኣብ 12 መዓልቲ ውሽጢ ይውዕል።",
            },
            {
              name: "_gid",
              domain: "Google Analytics",
              description:
                'ኩኪ ብ <a href="https://business.safety.google/adscookies/">Google Analytics</a> ተዘግበ።',
              expiration: "ዙርያ ጊዜ",
            },
          ],
        },
      },
    ],
  },
};

const servicesLabel = "ምክትታል ናይ ትንታነት ማእቀፍ ኣብ ምሕካብ፣ ንምሳሌ ናይ ጊዜ ቆይታ።";

export { translation, servicesLabel };
